var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sticky-slot-demo"}},[_vm._m(0),_vm._v(" "),_c('sticky-slot',{attrs:{"on-docked":_vm.myCallback}},[_c('div',{staticClass:"d-flex justify-content-center my-3"},[_vm._v("\n      sticky content\n    ")])])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-filler d-flex justify-content-center align-items-center mb-4"},[_c('span',[_vm._v("Filler content")])])
}]

export { render, staticRenderFns }